import React from "react";
import { Selector, Text } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const ExitApp = ({ confirmationOptions, onItemSelected }) => {
  return (
    <>
      <Text text={i18n.get("global.modals.exit.text")} />
      <Selector items={confirmationOptions} onItemSelected={onItemSelected} selectedIndex={0} />
    </>
  );
};
